export default __webpack_public_path__ + "static/media/check.fc79f8fc.svg";